import React from 'react';
import { Clock, Gauge, ArrowRight } from 'lucide-react';
import { Reveal } from '../hooks/useReveal';
import { IMAGES, COURSES } from '../data/mock';
import { Link } from 'react-router-dom';
import PageHero from '../components/PageHero';
import TrialCTA from '../components/TrialCTA';

export default function Cours() {
  return (
    <>
      <PageHero
        eyebrow="Nos cours"
        title="Trouve ton"
        accent="format"
        img="wallball"
        subtitle="Des cours en effectif limité pour un coaching de qualité. Que tu veuilles découvrir, progresser ou performer, il y a un cours pour toi."
      />

      <section className="py-14 md:py-28 max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {COURSES.map((c, i) => (
            <Reveal key={c.name} delay={(i % 3) * 100}>
              <div className="hx-card group rounded-md overflow-hidden h-full flex flex-col">
                <div className="h-52 overflow-hidden relative">
                  <img src={IMAGES[c.img]} alt={c.name} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#131313] to-transparent" />
                  <h3 className="absolute bottom-4 left-5 font-display text-2xl group-hover:text-accent transition-colors">{c.name}</h3>
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <div className="flex gap-4 mb-4">
                    <span className="inline-flex items-center gap-1.5 text-[var(--hx-muted)] text-xs font-cond tracking-wider"><Clock size={14} className="text-accent" />{c.duration}</span>
                    <span className="inline-flex items-center gap-1.5 text-[var(--hx-muted)] text-xs font-cond tracking-wider"><Gauge size={14} className="text-accent" />{c.level}</span>
                  </div>
                  <p className="text-[var(--hx-muted)] text-sm leading-relaxed flex-1">{c.desc}</p>
                  <Link to="/contact" className="inline-flex items-center gap-1 text-accent font-cond text-sm tracking-wider mt-5">
                    Réserver <ArrowRight size={15} className="transition-transform group-hover:translate-x-1" />
                  </Link>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <TrialCTA />
    </>
  );
}
